import React from 'react';
import corpoSilhuetaCostas from '../images/corpoSilhuetaCostas.jpg'
import corpoSilhuetaFrente from '../images/corpoSilhuetaFrente.jpg'
import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import type { IclickPositions } from '..';
import { useHookstate } from '@hookstate/core';

interface BodyMarkingsProps {
  readonly clickPositions: IclickPositions[];
  readonly disabled?: boolean;
  readonly side?: 'front' | 'back';
  readonly isPrint?: boolean;
  readonly handlePress?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, isFront: boolean) => void;
}

export default function BodyMarkings({ clickPositions, handlePress, disabled, side, isPrint }: BodyMarkingsProps) {

  return (
    <Button
      disableRipple
      // disabled={disabled}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        handlePress ? handlePress(event, side === 'front' ? true : false) : false;
      }}
      style={{
        position: 'relative',
        padding: 0,
        minWidth: 'auto',
        background: 'transparent',
        border: 'none',
        cursor: isPrint || disabled ? 'default' : 'pointer',
        color: 'black',
      }}
    >
      <Grid
        item
        sx={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}
      >
        <img
          src={side === 'front' ? corpoSilhuetaFrente : corpoSilhuetaCostas}
          alt={'form-builder-image'}
          style={{
            width: '500px',
            height: '500px'
          }} />
        {
          clickPositions.map((pos) => (
            <Box key={`${side}-${pos.xPosition}-${pos.yPosition}-${pos.injury_type_id}`}>
              <Tooltip title={pos.name}              >
                <Grid
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                  }}
                  item
                  style={{
                    left: pos.xPosition * 500 - 15,
                    top: pos.yPosition * 500 - 15,
                    position: 'absolute',
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    backgroundColor: 'red',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                  }}
                >
                  <Typography style={{ color: 'white', fontSize: 16 }}>
                    {pos.acronym}
                  </Typography>
                </Grid>
              </Tooltip>
            </Box>
          ))

        }
        {/* <Box width={'100%'} display={'flex'} flexDirection={'column'} alignItems={'center'} gap={1} >
          {
            isPrint && Array.isArray(clickPositions) && clickPositions.map((pos) => {
              if (itensRender.get().some((item) => item === pos.injury_type_id)) return null;
              
              itensRender.merge([pos.injury_type_id])
              return (
                <Typography variant='subtitle2' key={`print-${pos.xPosition}-${pos.yPosition}-${pos.injury_type_id}`}>
                  {`${pos.acronym} : ${pos.name}`}
                </Typography>
              )
            })
          }
        </Box> */}
      </Grid>
    </Button>
  )
}